import { postFetch } from '../fetch';
import { apiConfig } from '../config';
import { WebserviceProjectResponse } from './get-webservice-project';

export interface WebserviceSavedAnswerLink {
    answer_link: string;
}

export function postWebserviceSaveProject(
    project: string,
    files: WebserviceProjectResponse['files'],
): Promise<WebserviceSavedAnswerLink> {
    const { apiPostWebserviceSaveProject } = apiConfig.getStaticUrls();
    return postFetch(apiPostWebserviceSaveProject, { project, files });
}
